export const validationMixin = {
  methods: {
    /**
     * Sanitiza CNPJ removendo apenas pontuação (preserva letras e dígitos).
     */
    sanitizeCnpj(cnpj) {
      return cnpj.replace(/[^0-9A-Za-z]/g, '');
    },

    /**
     * Verifica se o CNPJ contém letras (é alfanumérico).
     */
    isAlphanumericCnpj(cnpj) {
      return /[A-Za-z]/.test(this.sanitizeCnpj(cnpj));
    },

    /**
     * Valida CNPJ — detecta automaticamente se é numérico (tradicional) ou
     * alfanumérico (novo formato Receita Federal) e aplica o algoritmo correto.
     */
    validateCnpj(cnpj) {
      const clean = this.sanitizeCnpj(cnpj);

      // Se contém letras → alfanumérico, senão → numérico (código original)
      if (/[A-Za-z]/.test(clean)) {
        return this.validateCnpjAlphanumeric(clean);
      }
      return this.validateCnpjNumeric(clean);
    },

    /**
     * Validação do CNPJ numérico tradicional (somente dígitos).
     */
    validateCnpjNumeric(cnpj) {
      cnpj = cnpj.replace(/[^\d]+/g, '');

      if (cnpj === '') return false;

      if (cnpj.length !== 14) return false;

      // Elimina CNPJs invalidos conhecidos
      if (
        cnpj === '00000000000000' ||
        cnpj === '11111111111111' ||
        cnpj === '22222222222222' ||
        cnpj === '33333333333333' ||
        cnpj === '44444444444444' ||
        cnpj === '55555555555555' ||
        cnpj === '66666666666666' ||
        cnpj === '77777777777777' ||
        cnpj === '88888888888888' ||
        cnpj === '99999999999999'
      )
        return false;

      // Valida DVs
      let size = cnpj.length - 2;
      let number = cnpj.substring(0, size);
      const digit = cnpj.substring(size);
      let sum = 0;
      let pos = size - 7;
      for (let i = size; i >= 1; i--) {
        sum += number.charAt(size - i) * pos--;
        if (pos < 2) pos = 9;
      }
      let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
      if (result != digit.charAt(0)) return false;

      size += 1;
      number = cnpj.substring(0, size);
      sum = 0;
      pos = size - 7;
      for (let i = size; i >= 1; i--) {
        sum += number.charAt(size - i) * pos--;
        if (pos < 2) pos = 9;
      }
      result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
      if (result != digit.charAt(1)) return false;

      return true;
    },

    /**
     * Converte caractere alfanumérico para valor numérico conforme Receita Federal.
     * Dígitos: 0-9 = 0-9 | Letras: A=17, B=18, ..., Z=42
     */
    cnpjCharToValue(char) {
      const c = char.toUpperCase();
      if (c >= '0' && c <= '9') {
        return parseInt(c, 10);
      }
      return c.charCodeAt(0) - 'A'.charCodeAt(0) + 17;
    },

    /**
     * Validação do CNPJ alfanumérico (novo formato Receita Federal).
     * Letras são convertidas para valores numéricos (A=17, B=18, ..., Z=42)
     * antes do cálculo dos dígitos verificadores.
     */
    validateCnpjAlphanumeric(cnpj) {
      cnpj = cnpj.toUpperCase();

      if (cnpj === '' || cnpj.length !== 14) return false;

      // Verifica se contém apenas caracteres válidos (dígitos e letras A-Z)
      if (!/^[0-9A-Z]{14}$/.test(cnpj)) return false;

      // Elimina CNPJs com todos os caracteres iguais
      if (/^(.)\1{13}$/.test(cnpj)) return false;

      // Converte cada caractere para valor numérico
      const values = [];
      for (let i = 0; i < 14; i++) {
        values.push(this.cnpjCharToValue(cnpj.charAt(i)));
      }

      // Valida primeiro dígito verificador
      const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      let sum = 0;
      for (let i = 0; i < 12; i++) {
        sum += values[i] * weights1[i];
      }
      let rest = sum % 11;
      const dv1 = rest < 2 ? 0 : 11 - rest;
      if (values[12] !== dv1) return false;

      // Valida segundo dígito verificador
      const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3];
      sum = 0;
      for (let i = 0; i < 12; i++) {
        sum += values[i] * weights2[i];
      }
      sum += dv1 * 2;
      rest = sum % 11;
      const dv2 = rest < 2 ? 0 : 11 - rest;

      return values[13] === dv2;
    },
    validateCpf(cpf) {
      if (typeof cpf !== 'string') return false;
      cpf = cpf.replace(/[\s.-]*/gim, '');
      if (cpf.length !== 11 || !Array.from(cpf).filter((e) => e !== cpf[0]).length) {
        return false;
      }
      let sum = 0;
      let rest;
      for (var i = 1; i <= 9; i++) sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
      rest = (sum * 10) % 11;
      if (rest == 10 || rest == 11) rest = 0;
      if (rest != parseInt(cpf.substring(9, 10))) return false;
      sum = 0;

      for (var i = 1; i <= 10; i++) sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
      rest = (sum * 10) % 11;
      if (rest == 10 || rest == 11) rest = 0;
      if (rest != parseInt(cpf.substring(10, 11))) return false;
      return true;
    },
  },
};
